import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const PortalSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default PortalSVG;
